import Swiper from 'swiper';
import { FreeMode, Mousewheel } from 'swiper/modules';
import { MOBILE } from '../../assets/scripts/constants';

class Unpacking {
	constructor(el) {
		this.container = el;
		this.mm = window.matchMedia(MOBILE);
		this.swiper = null;

		this.mobileFirstSlide = this.container.querySelector('.unpacking__mobile-first-slide');
		this.sliderContainer = this.container.querySelector('.unpacking__slider');
		this.gallery = this.container.querySelector('[data-gallery="ignore"]');
		this.swiperWrapper = this.gallery.querySelector('.swiper-wrapper');

		this.originalSlides = Array.from(this.swiperWrapper.children);

		this.init();

		this.mm.addEventListener('change', (e) => {
			this.handleResize(e.matches);
		});
	}

	init() {
		this.handleResize(this.mm.matches);
	}

	handleResize(isMobile) {
		if (isMobile) {
			this.setupMobileLayout();
		} else {
			this.setupDesktopLayout();
		}
	}

	setupMobileLayout() {
		if (this.mobileFirstSlide) {
			this.mobileFirstSlide.style.display = 'block';
		}

		this.removeFirstSlideFromSwiper();

		this.initSwiper();
	}

	setupDesktopLayout() {
		if (this.mobileFirstSlide) {
			this.mobileFirstSlide.style.display = 'none';
		}

		this.restoreFirstSlideToSwiper();

		this.reinitSwiper();
	}

	removeFirstSlideFromSwiper() {
		const firstSlide = this.swiperWrapper.querySelector('[data-slide-index="0"]');
		if (firstSlide && firstSlide.parentNode === this.swiperWrapper) {
			firstSlide.style.display = 'none';
		}
	}

	restoreFirstSlideToSwiper() {
		const firstSlide = this.swiperWrapper.querySelector('[data-slide-index="0"]');
		if (firstSlide) {
			firstSlide.style.display = '';
		}
	}

	initSwiper() {
		if (this.swiper) {
			this.destroySwiper();
		}

		if (!this.gallery) return;

		this.buttonPrev = this.gallery.querySelector('.gallery__nav-button._prev');
		this.buttonNext = this.gallery.querySelector('.gallery__nav-button._next');

		this.swiper = new Swiper(this.gallery.querySelector('.swiper'), {
			modules: [Mousewheel, FreeMode],
			slidesPerView: 'auto',
			spaceBetween: 2,
			watchSlidesProgress: true,
			freeMode: true,
			mousewheel: {
				forceToAxis: true,
				releaseOnEdges: true,
				sensitivity: 1,
			},
			on: {
				init: (swiper) => {
					if (this.buttonPrev) this.buttonPrev.disabled = swiper.isBeginning;
					if (this.buttonNext) this.buttonNext.disabled = swiper.isEnd;
				},
				slideChange: (swiper) => {
					if (this.buttonPrev) this.buttonPrev.disabled = swiper.isBeginning;
					if (this.buttonNext) this.buttonNext.disabled = swiper.isEnd;
				},
			},
		});

		if (this.buttonPrev) {
			this.buttonPrev.addEventListener('click', (this.slidePrev = () => this.swiper.slidePrev()));
		}
		if (this.buttonNext) {
			this.buttonNext.addEventListener('click', (this.slideNext = () => this.swiper.slideNext()));
		}
	}

	reinitSwiper() {
		if (this.swiper) {
			this.swiper.update();
		} else {
			this.initSwiper();
		}
	}

	destroySwiper() {
		if (this.swiper) {
			if (this.buttonPrev && this.slidePrev) {
				this.buttonPrev.removeEventListener('click', this.slidePrev);
			}
			if (this.buttonNext && this.slideNext) {
				this.buttonNext.removeEventListener('click', this.slideNext);
			}
			this.swiper.destroy(true, true);
			this.swiper = null;
		}
	}
}

document.querySelectorAll('[data-unpacking]').forEach((el) => new Unpacking(el));

export default Unpacking;
